import MemberTelephoneService from "../../services/MemberTelephoneService";
export const SET_PHONE_NUMBER = "SET_PHONE_NUMBER";
export const DELETE_PHONE_NUMBER = "DELETE_PHONE_NUMBER";

export function changePhoneNumber(membershipNumber, changePhoneNumberObj) {
  let service = new MemberTelephoneService();
  return dispatch =>
    service
      .UpdateMemberTelephoneNumbers(membershipNumber, changePhoneNumberObj)
      .then(data => {
        dispatch({
          type: SET_PHONE_NUMBER,
          payload: {
            MembershipNumber: membershipNumber,
            TelephoneNumber: data.Number
          }
        });
        return data;
      });
}

export function deletePhoneNumber(membershipNumber, type) {
  let service = new MemberTelephoneService();
  return dispatch =>
    service.DeleteMemberTelephoneNumber(membershipNumber, type).then(data => {
      dispatch({
        type: DELETE_PHONE_NUMBER,
        payload: {
          MembershipNumber: membershipNumber,
          PhoneNumberType: type
        }
      });
      return data;
    });
}
